function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><title>button / circle / right</title><g fillRule="nonzero" fill="#42444C"><path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-1.818a8.182 8.182 0 1 0 0-16.364 8.182 8.182 0 0 0 0 16.364z" /><path d="M9.357 7.006a.91.91 0 0 1 1.286-1.285l3.636 3.636a.91.91 0 0 1 0 1.286l-3.636 3.636a.91.91 0 1 1-1.286-1.285L12.351 10 9.357 7.006z" /><path d="M6.364 10.91a.91.91 0 0 1 0-1.82h7.272a.91.91 0 1 1 0 1.82H6.364z" /></g></svg>;
});